// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from './modules/logger/logger';

import Freezer from 'freezer-js';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let xhr = {};
let i18n = {};
let i18nJson = {};

const notification = $('notification');
let saveTimeout = undefined;
let isInit = true;

const defaultEditorStoreStructure = {
    design: {},
    map: {},
    nodes: {},
    edges: {}
};

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Store {

    constructor() {}

    init(globalXhr, globalI18n) {
        log('store init');

        // global objects
        store = new Freezer(defaultEditorStoreStructure);
        xhr = globalXhr;
        i18n = globalI18n;
        i18nJson = i18n.getCurrentJson();

        setStoreEventListener();
    }

    get() {
        return store.get();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------
function setStoreEventListener() {
    // after all
    store.on('update', (currentState, prevState) => {
        const currentStateWithoutPosition = currentState.toJS();
        currentStateWithoutPosition.map.position = {};
        const prevStateWithoutPosition = prevState.toJS();
        prevStateWithoutPosition.map.position = {};

        // only cancel or start auto save if the map has really changed and it was not just moved
        if (!deepIsEqual(currentStateWithoutPosition, prevStateWithoutPosition)) {

            // show auto saved notification
            clearTimeout(saveTimeout);
            saveTimeout = setTimeout(() => {

                // check if init
                if(isInit === true) {
                    isInit = false;

                // save store data and notify user
                } else {
                    xhr.saveStoredData();

                    notification.find('span').text(i18nJson.notifications.success.mapSaved);
                    notification.removeClass('hide');

                    setTimeout(() => {
                        notification.addClass('hide');
                    }, 2000);
                }
            }, 1400);

        }
    });
}

// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function deepIsEqual(first, second) {
    // If first and second are the same type and have the same value
    // Useful if strings or other primitive types are compared
    if (first === second)
        return true;
    
    if ((first == null && second != null) || (first != null && second == null))
        return false;

    if ((first == null && second != null) || (first != null && second == null))
        return false;

    // Try a quick compare by seeing if the length of properties are the same
    let firstProps = Object.getOwnPropertyNames(first);
    let secondProps = Object.getOwnPropertyNames(second);

    // Check different amount of properties
    if (firstProps.length !== secondProps.length)
        return false;

    // Go through properties of first object
    for (var i = 0; i < firstProps.length; i++) {
        let prop = firstProps[i];
        // Check the type of property to perform different comparisons
        switch (typeof (first[prop])) {
            // If it is an object, decend for deep compare
            case 'object':
                if (!deepIsEqual(first[prop], second[prop]))
                    return false;
                break;
            case 'number':
                // with JavaScript NaN != NaN so we need a special check
                if (isNaN(first[prop]) && isNaN(second[prop]))
                    break;
            default:
                if (first[prop] !== second[prop])
                    return false;
        }
    }
    return true;
}
